export const cardNames = [
  {
    title: "Web development",
    button: "Choose",
    link: "/webdev",
  },
  {
    title: "Data Science",
    button: "Choose",
    link: "/datascience",
  },
  {
    title: "Data Marketing",
    button: "Choose",
    link: "/datamarketing",
  },
  {
    title: "Design",
    button: "Choose",
    link: "/design",
  },
];

export const FooterEl = [
  {
    title: "Do you want to learn hands on digital skills",
    location: "https://codepreneurs.brainster.co/",
    button: "Visit Brainster",
    color: 'bg-warning'
  },
  {
    title: "Do you want to receive job offers by IT Companies?",
    location: "https://www.wearelaika.com/",
    button: "Visit Laika",
    color: 'bg-primary'
  },
];
